import { render, staticRenderFns } from "./InOrdersDetail.vue?vue&type=template&id=2a8cdd8a&scoped=true&lang=pug&"
import script from "./InOrdersDetail.vue?vue&type=script&lang=js&"
export * from "./InOrdersDetail.vue?vue&type=script&lang=js&"
import style0 from "./InOrdersDetail.vue?vue&type=style&index=0&id=2a8cdd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8cdd8a",
  null
  
)

export default component.exports